import { AdjustmentType, DisputeType } from 'enums';

const InvoiceTypes = [
    AdjustmentType.Pricing,
    AdjustmentType.Quantity,
    AdjustmentType.SpecialPricing,
];

type DisputeTypeInfo = {
    disputeType: DisputeType,
    isInvoice: boolean,
    isPayment: boolean,
};

export default function useDisputeType(type: AdjustmentType) : DisputeTypeInfo {   
    const disputeType = InvoiceTypes.includes(type) ? DisputeType.Invoice : DisputeType.Payment;

    return {
        disputeType,
        isInvoice: disputeType === DisputeType.Invoice,
        isPayment: disputeType === DisputeType.Payment,
    };
}